import { useSelector } from 'react-redux';

import {
  getCommonReducer,
  NativeAuthStatus,
  setActivePopup,
  setBlobUrlEnabled,
  setIsDirectPlayerAccess,
  setIsMinimized,
  setIsUnloggedGenerationModalOpen,
  setNativeAuthStatus,
  setPlaylistOpen,
  setSelectedContributorSlug,
  setSidebarOpen,
} from '../../store/reducers/commonStore';
import { AppDispatch, useAppDispatch } from '../../store/store';

export const useCommonState = () => {
  const state = useSelector(getCommonReducer);
  const dispatch: AppDispatch = useAppDispatch();

  return {
    ...state,
    setSidebarOpen: (sidebarOpen: boolean) =>
      dispatch(setSidebarOpen(sidebarOpen)),
    setActivePopup: (activePopup: string) =>
      dispatch(setActivePopup(activePopup)),
    setIsMinimized: (isMinimized: boolean) =>
      dispatch(setIsMinimized(isMinimized)),
    setPlaylistOpen: (playlistOpen: boolean) =>
      dispatch(setPlaylistOpen(playlistOpen)),
    setIsDirectPlayerAccess: (isDirectPlayerAccess: boolean) =>
      dispatch(setIsDirectPlayerAccess(isDirectPlayerAccess)),
    setIsUnloggedGenerationModalOpen: (isOpen: boolean) =>
      dispatch(setIsUnloggedGenerationModalOpen(isOpen)),
    setBlobUrlEnabled: (blobUrlEnabled: boolean) =>
      dispatch(setBlobUrlEnabled(blobUrlEnabled)),
    setSelectedContributorSlug: (slug: string | null) =>
      dispatch(setSelectedContributorSlug(slug)),
    setNativeAuthStatus: (status: NativeAuthStatus) =>
      dispatch(setNativeAuthStatus(status)),
  };
};
